/**
 * Galaxy Knowledge Base View — routes and window-global bindings.
 *
 * Rendering logic is split across:
 *   kb_list.ts    — list view, state, interaction handlers
 *   kb_detail.ts  — detail view
 *   kb_types.ts   — shared color helpers
 */

import { route } from '../../router.js'
import {
  renderKBListView,
  setKbTypeFilter,
  toggleKbTag,
  setKbSort,
  setKbSearch,
  setKbPage,
  clearKbFilters,
  goToKbWithTag,
} from './kb_list.js'
import {
  setKbView,
  setKbUsageSort,
  setReadsType,
  openReadsCell,
  closeReadsCell,
} from './kb_usage.js'
import { renderKBDetailView } from './kb_detail.js'

// ─── Routes ─────────────────────────────────────────────────────────────────

route('/kb', () => {
  void renderKBListView()
})

route('/kb/:entry_id', (params) => {
  if (params.entry_id) {
    void renderKBDetailView(params.entry_id)
  }
})

// ─── Window-exposed interaction handlers ────────────────────────────────────

// Types live in action-registry.ts Window interface augmentation
window.setKbTypeFilter = setKbTypeFilter
window.toggleKbTag = toggleKbTag
window.setKbSort = setKbSort
window.setKbSearch = setKbSearch
window.setKbPage = setKbPage
window.clearKbFilters = clearKbFilters
window.goToKbWithTag = goToKbWithTag
window.setKbView = setKbView
window.setKbUsageSort = setKbUsageSort
// Heatmap controls live in the Usage tab now, not on a page of their own.
window.setReadsType = setReadsType
window.openReadsCell = openReadsCell
window.closeReadsCell = closeReadsCell
